import moment from 'moment';
import {
  ON_ADD_HASHTAG,
  ON_ADD_DEFAULT_HASHTAG,
  SET_HASHTAG_DATA,
  ADD_HASHTAGS_DATA,
  DEFAULT_HASHTAG,
  SET_TITLE_HASHTAG_HEIGHT,
  MAX_COUNT_HASHTAG,
  HASHTAGS_LOADING,
} from '../../constants';
import {
  reloadAllGallery,
  calculateGalleryHeight,
} from '../gallery/galleryHeight';
import { getHashtagMediaApi } from '../api/hashtagApi';

import { SORT_HASHTAG_OPTIONS } from '../../constants/settingsConstants';
import { GALLERY_TYPES } from '../../constants/proGalleryConstants';
import WixService from './WixService';
import store from '../../store';

const COUNT = MAX_COUNT_HASHTAG + 1;

/**
 * Add new Hashtag
 * @param {Object} newHashtag - { hashtagName, hashtagId } of new hashtag
 */
export const addHashtag = (newHashtag) => async (dispatch) => {
  let { hashtags } = store.getState().appReducer;
  hashtags = JSON.parse(JSON.stringify(hashtags));

  hashtags.push(newHashtag);
  dispatch(getAllHashtagsItems(hashtags));
};

const hashtagLoading = () => ({
  type: HASHTAGS_LOADING,
});

/**
 * Get medias of hashtags
 * @param {Array} hashtags - all hashtags selected.
 * @param {Number} count - count of hashtags need to get.
 */
export const getAllHashtagsItems = (hashtags, count) => (dispatch) => {
  dispatch(hashtagLoading());
  if (!hashtags.length) {
    dispatch(getDefaultHashtagMedias(count));
    return;
  }
  if (!count) {
    count = COUNT;
  }

  count = Math.ceil(count / hashtags.length);

  const arr = hashtags.map(({ hashtagId }) => {
    return getHashtagMediaApi(hashtagId, count);
  });

  return Promise.all(arr).then((res) => {
    res.forEach((data, index) => {
      hashtags[index] = {
        ...hashtags[index],
        ...data,
      };
    });

    dispatch({
      type: ON_ADD_HASHTAG,
      payload: hashtags,
    });

    const allHashtags = orderHashtags(hashtags);
    dispatch({
      type: SET_HASHTAG_DATA,
      payload: allHashtags,
    });

    dispatch(calculateGalleryHeight(GALLERY_TYPES.HASHTAG));

    return allHashtags;
  });
};

const getDefaultHashtagMedias = (count) => (dispatch) => {
  const defaultHashtags = [DEFAULT_HASHTAG];
  if (!count) {
    count = COUNT;
  }
  const demoHashtagId = WixService.isEditorX()
    ? defaultHashtags[0].hashtagIdEditorX
    : defaultHashtags[0].hashtagId;
  return getHashtagMediaApi(demoHashtagId, count).then((data) => {
    if (data && data.items) {
      defaultHashtags[0] = {
        ...defaultHashtags[0],
        ...data,
      };

      const allHashtags = orderHashtags(defaultHashtags);
      dispatch({
        type: ON_ADD_HASHTAG,
        payload: [],
      });
      dispatch({
        type: ON_ADD_DEFAULT_HASHTAG,
        payload: defaultHashtags,
      });
      dispatch({
        type: SET_HASHTAG_DATA,
        payload: allHashtags,
      });

      dispatch(calculateGalleryHeight(GALLERY_TYPES.HASHTAG));
    }
    return;
  });
};

/**
 * Get more hashtags
 * @param {Array} hashtags - All hashtags selected.
 * @param {Number} isDefault - is default images.
 */
export const getMoreHashtags = (hashtags, isDefault, typeActionMoreData) => (
  dispatch,
) => {
  const count = Math.ceil((COUNT * 2) / hashtags.length);

  const arr = hashtags.map(({ hashtagId, pagination }) => {
    return getHashtagMediaApi(hashtagId, count, pagination.after);
  });

  Promise.all(arr).then((res) => {
    let newHashtags = [];
    res.map(({ items, pagination }, index) => {
      if (items) {
        newHashtags = newHashtags.concat(items);
        hashtags[index] = {
          ...hashtags[index],
          items: hashtags[index].items.concat(items),
          pagination,
        };
      }
    });

    dispatch({
      type: isDefault ? ON_ADD_DEFAULT_HASHTAG : ON_ADD_HASHTAG,
      payload: hashtags,
    });

    const data = orderHashtags(hashtags, newHashtags);

    dispatch({
      type: ADD_HASHTAGS_DATA,
      payload: data,
    });

    dispatch({
      type: typeActionMoreData,
      payload: {
        isLoadingMore: false,
      },
    });
  });
};

/**
 * Sort Hashtags by Recent or Viewed
 * @param {Array} hashtags - all hashtags selected.
 */
export const orderHashtags = (hashtags, data, isRecent) => {
  hashtags = JSON.parse(JSON.stringify(hashtags));
  const { sortHashtagsFeed } = store.getState().settingsReducer;
  isRecent = isRecent || sortHashtagsFeed === SORT_HASHTAG_OPTIONS.MOST_RECENT;

  let allHashtags = [];
  if (data) {
    allHashtags = data;
  } else {
    hashtags.forEach((hashtag) => {
      allHashtags = allHashtags.concat(hashtag.items);
    });
  }

  allHashtags.sort(isRecent ? sortByRecent : sortByViewed);
  return allHashtags;
};

const sortByRecent = (a, b) => {
  const aDate = a.originalData.timestamp;
  const bDate = b.originalData.timestamp;

  if (moment(aDate).isBefore(bDate)) {
    return 1;
  }
  if (moment(bDate).isBefore(aDate)) {
    return -1;
  }
  return 0;
};

const sortByViewed = (a, b) => {
  const aCountLike = a.originalData.like_count;
  const bCountLike = b.originalData.like_count;
  if (aCountLike < bCountLike) {
    return 1;
  }
  if (aCountLike > bCountLike) {
    return -1;
  }
  return 0;
};

export const setTitleHashtagHeight = (height) => (dispatch) => {
  dispatch({
    type: SET_TITLE_HASHTAG_HEIGHT,
    payload: height,
  });
  dispatch(reloadAllGallery());
};
